<template>
  <section class="comic">
    <loader fill v-if="loading" />
    <div class="comic__strip" v-else>
      <strip v-if="strip" v-bind="strip" />
      <div class="comic__error" v-else>
        <h3>🚨</h3>
        <p>This strip is not available</p>
        <router-link :to="{name: 'Home'}">
          <span class="g-button">Go Home</span>
        </router-link>
      </div>
      <controls v-if="strip" v-bind="strip" />
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Loader from '@/components/Loader.vue';
import Strip from './comic/Strip.vue';
import Controls from './comic/Controls.vue';

export default {
  name: 'Comic',
  components: {
    Loader,
    Strip,
    Controls,
  },
  data() {
    return {
      loading: true,
    };
  },
  computed: {
    ...mapGetters([
      'getStrip',
    ]),
    stripNumber() {
      return this.$route.params.stripNumber;
    },
    strip() {
      return this.getStrip(this.stripNumber, { isPublished: true });
    },
  },
  created() {
    this.fetchLatestStrip().finally(() => {
      this.load();
    });
  },
  watch: {
    $route() {
      this.load();
    },
  },
  methods: {
    ...mapActions([
      'fetch',
      'fetchLatestStrip',
      'fetchStrip',
      'set',
    ]),
    load() {
      this.loading = true;
      const { stripNumber } = this;
      this.set({ model: 'lastRead', value: stripNumber });
      this.fetchStrip({ stripNumber }).finally(() => {
        this.setup();
      });
    },
    setup() {
      if (this.strip && !this.strip.userCanRead) {
        const { stripNumber } = this;
        const { season } = this.strip;
        this.$router.push({
          name: 'BuySeason',
          params: {
            seasonId: season.id,
          },
          query: {
            stripNumber,
          },
        });
      }
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.comic {
  width: 100%;
  position: relative;
  min-height: calc(100vh - 300px);
  &__error {
    margin: 0 auto;
    text-align: center;
  }
}
</style>
